const surveyorRouter = [
  {
    path: '/surveyor',
    name: 'Surveyor',
    component: () => import('@/views/wxapp/surveyor'),
    meta: {
      title: '勘测师'
    }
    // children: [
    //   {
    //     path: 'complaint-list',
    //     name: 'ComplaintList',
    //     component: () => import('@/views/wxapp/surveyor/index'),
    //     meta: {
    //       title: '客诉处理'
    //     }
    //   }
    // ]
  }
]
export default surveyorRouter
